import React, { createContext, useContext, useEffect, useState } from "react";

// ============================================================================
// ThemeContext — mode terang/gelap ETAMSIOS (#4b-1, STANDAR_UI v1.1 A7).
//
// Keputusan Owner:
// - Q63: preferensi tema disimpan PER PERANGKAT di localStorage
//   (BUKAN kolom user_profiles — tidak ada migration untuk ini).
// - Q69: toggle mode gelap SENGAJA BELUM DIRENDER di UI mana pun, karena
//   halaman di luar Purchasing belum disapu ke token dan akan rusak visual
//   di mode gelap. Mekanisme di file ini tetap dibangun penuh dan diuji.
//   Toggle baru boleh dipasang setelah sapuan menyeluruh selesai
//   (unit kerja terpisah).
//
// KONSEKUENSI Q69: default SELALU "light" — TIDAK mengikuti
// prefers-color-scheme. Kalau ikut preferensi OS, user ber-OS gelap akan
// melihat halaman non-purchasing rusak tanpa pernah menekan apa pun.
// Saat sapuan menyeluruh selesai, baris default ini boleh diubah mengikuti
// preferensi OS.
//
// Cara uji manual saat pengembangan (tanpa toggle):
//   localStorage.setItem("etams-theme", "dark"); location.reload();
// ============================================================================

const STORAGE_KEY = "etams-theme";

const ThemeContext = createContext({
  theme: "light",
  setTheme: () => {},
  toggleTheme: () => {},
});

function readStoredTheme() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === "dark" || stored === "light") return stored;
  } catch {
    // localStorage bisa tidak tersedia (private mode ketat) — jatuh ke light.
  }
  return "light"; // Q69 — lihat catatan di atas.
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(readStoredTheme);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      // Gagal simpan bukan alasan menjatuhkan aplikasi.
    }
  }, [theme]);

  const setTheme = (next) => {
    setThemeState(next === "dark" ? "dark" : "light");
  };
  const toggleTheme = () => {
    setThemeState((t) => (t === "dark" ? "light" : "dark"));
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
